// src/components/NavBar.jsx
import React from "react";
import NavItem from "./NavItem"; // Import NavItem
// import insperitylogo from "../assets/images/insperity-logo.png";
import insperitylogo from "../assets/images/logo_3.png";

const NavBar = ({ setCurrentPage, currentPage }) => {
  const logoUrl =
    "https://placehold.co/200x60/00BCD4/FFFFFF?text=INSperity+Games";

  return (
    <nav className="navbar-gradient p-4 shadow-xl rounded-b-3xl sticky top-0 z-50">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        {/* Logo and Site Title */}
        <div className="flex items-center space-x-4 mb-4 md:mb-0">
          <img
            src={insperitylogo}
            alt="Insperity Games Logo"
            // className="h-12 w-auto rounded-lg shadow-md border-2 border-amber-300"
            className="h-16 w-auto mr-2"
          />
          <span className="text-white text-3xl font-extrabold font-inter tracking-wider drop-shadow-lg">
            Insperity Games
          </span>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center md:justify-end gap-x-8 gap-y-2 text-lg">
          <NavItem
            page="home"
            label="Home"
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
          <NavItem
            page="about"
            label="About Us"
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
          <NavItem
            page="contact"
            label="Contact Us"
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
          <NavItem
            page="privacy"
            label="Privacy Policy"
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
